// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608030150/js/" + chunkId + "." + {"44":"60652c3b","225":"632afcf6","481":"d2e77986","486":"d3e8ed26","770":"b3bb58fe"}[chunkId] + ".0.4429067133134801.chunk.js";
};